import React, { useEffect, useState } from "react";
import { useIdleTimer } from "react-idle-timer";
import { useDispatch } from "react-redux";
import { useMsal } from "@azure/msal-react";
import { userActions } from "common/redux/user";
import { Button, Icon, Modal } from "common/components";
import { SESSION_TIMEOUT, protectedResources } from "common/config/auth.config";
import { ReactComponent as SessionTimeoutIcon } from "assets/media/icons/custom/sessionTimeoutIcon.svg";

import "./SessionTimeoutModal.scss";

let countInterval: any = undefined;
let time: any = undefined;
const COUNT_DOWN_MINUTES = "03";
const COUNT_DOWN_SECONDS = "00";

type Timer = {
  countdownMinutes: string | number;
  countdownSeconds: string | number;
};

const SessionTimeOutModal = () => {
  const dispatch = useDispatch();
  const { instance } = useMsal();

  const [showModal, setShowModal] = useState(false);

  const [countdownTime, setCountdownTime] = useState<Timer>({
    countdownMinutes: COUNT_DOWN_MINUTES,
    countdownSeconds: COUNT_DOWN_SECONDS
  });

  useEffect(() => {
    return () => {
      reset();
      clearInterval(countInterval);
    };
  }, []);

  const handleIdle = () => {
    pause();
    setShowModal(true);

    let min = 0;
    let sec = 0;
    const initialTime = new Date().getTime();

    countInterval = setInterval(function () {
      const now = new Date().getTime();
      time = now - initialTime;
      const secondsLeft = 180000 - time;
      min = Math.floor(secondsLeft / 60000);
      sec = Math.floor((secondsLeft % 60000) / 1000);

      const runningCountdownTime = {
        countdownMinutes: min < 10 ? "0" + min : min,
        countdownSeconds: sec < 10 ? "0" + sec : sec
      };
      setCountdownTime(runningCountdownTime);

      if (time > 180000) {
        clearInterval(countInterval);
        reset();
        dispatch(userActions.logoutUserBegin());
      }
    }, 1000);
  };
  const { reset, pause } = useIdleTimer({
    onIdle: handleIdle,
    timeout: SESSION_TIMEOUT,
    debounce: 500
  });

  const handleModalClose = () => {
    dispatch(userActions.logoutUserBegin());
    setShowModal(false);
  };

  if (showModal) {
    return (
      <Modal
        title="Session timeout alert"
        size="md"
        show={showModal}
        footerElement={
          <>
            <Button
              variant="primary"
              type="button"
              onClick={() => {
                reset();
                setCountdownTime({
                  countdownMinutes: COUNT_DOWN_MINUTES,
                  countdownSeconds: COUNT_DOWN_SECONDS
                });
                clearInterval(countInterval);
                instance.acquireTokenSilent({
                  scopes: protectedResources.graph.scopes
                });
                setShowModal(false);
              }}
            >
              Extend
            </Button>
            <Button
              variant="secondary"
              type="button"
              onClick={() => {
                dispatch(userActions.logoutUserBegin());
              }}
            >
              Logout
            </Button>
          </>
        }
        onClose={handleModalClose}
      >
        <div className="session-timeout-content">
          <Icon src={<SessionTimeoutIcon />} isCustom={true} />
          <p>
            Your will be logged out in{" "}
            <span className="countdown-time">
              {countdownTime.countdownMinutes}:{countdownTime.countdownSeconds}{" "}
              minutes
            </span>{" "}
            due to inactivity. Please choose to extend your session or quit.
          </p>
        </div>
      </Modal>
    );
  } else return null;
};

export default SessionTimeOutModal;
